import { Link } from "react-router-dom";

/**
 * Friday Conversations mark — a static render of the brand's 3D "Chromatic Spiral"
 * logo (copper crescents flowing into a blue speech-bubble swirl). Lightweight PNG
 * with transparency so it sits on any theme.
 */
export function Logo({ className = "h-9 w-9" }) {
  return (
    <img
      src="/logo-mark.png"
      alt="Friday Conversations"
      className={`${className} object-contain select-none`}
      draggable="false"
    />
  );
}

export function Wordmark({ withTagline = false, className = "" }) {
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="brand-wordmark">
      <Logo className="h-9 w-9 shrink-0" />
      <div className="leading-none">
        <div className="font-semibold tracking-[0.16em] text-[0.95rem] text-foreground">FRIDAY</div>
        <div className="mt-[3px] tracking-[0.26em] text-[0.6rem] font-medium text-muted-foreground">
          CONVERSATIONS
        </div>
        {withTagline && (
          <div className="mt-1 text-[10px] text-muted-foreground/80">Real Conversations. Deeper Connection.</div>
        )}
      </div>
    </Link>
  );
}
